import { add, remove } from "@fluorescent/dom";
import { shouldAnimate, delayOffset } from "@/lib/animation";

const selectors = {
  animationItems: ".animation--container > *",
};

const classes = {
  isVisible: "is-visible",
};

export default node => {
  delayOffset(node, [selectors.animationItems]);

  // Trigger the reveal animation when the drawer is opened
  function open() {
    if (shouldAnimate(node)) {
      add(node, classes.isVisible);
    }
  }

  // Trigger the reveal animation when the drawer is opened
  function close() {
    if (shouldAnimate(node)) {
      remove(node, classes.isVisible);
    }
  }

  return {
    open,
    close,
  };
};
